import { colors } from '@/theme/colors';
import type { HeaderCellConfig } from '@/ui/table/table.types';

export const fileSuggestionsTableHeaders: HeaderCellConfig[] = [
  {
    columnKey: 'files',
    bgColor: colors.basics.white,
    withSort: false,
    padding: '20px 12px',
  },
  {
    columnKey: 'entityName',
    bgColor: colors.basics.white,
    withSort: false,
    padding: '20px 12px',
  },
  {
    columnKey: 'entityType',
    bgColor: colors.basics.white,
    withSort: false,
    padding: '20px 12px',
  },
  {
    columnKey: 'content',
    bgColor: colors.basics.white,
    withSort: false,
    padding: '20px 12px',
    width: '300px',
  },
  {
    columnKey: 'dateUploaded',
    bgColor: colors.basics.white,
    withSort: false,
    padding: '20px 12px',
  },
  {
    columnKey: 'owner',
    bgColor: colors.basics.white,
    withSort: false,
    padding: '20px 12px',
  },
];
